// extracted by mini-css-extract-plugin
export default {"ItemCardWrap":"StyleGuide_ItemCardWrap__8WEhU","ItemCard__copy":"StyleGuide_ItemCard__copy__VluNW","btnAnim":"StyleGuide_btnAnim__HkgRw","btnAnim2":"StyleGuide_btnAnim2__-vfix"};